import React from 'react';
import logo from '../HOmetutor.png';
import '../styles/Body.css';

const Body = () => {
    return (
        <div className='body' >
        <img src={logo} className="App-logo" alt="logo" />
            <p className='App-link'>
            Tutors page under re-construction actually
        </p>
        </div>
    );
};

export default Body; 